// extracted by mini-css-extract-plugin
export default {"file-type-container":"FileType_file-type-container__buF03","file-type-icon-button":"FileType_file-type-icon-button__u7Pmp"};